export default [
  {
    name: 'Layout',
    open: false,
    properties: [
      { extend: 'display', type: 'select', options: [
        { id: 'block', label: 'Block' },
        { id: 'flex', label: 'Flex' },
        { id: 'grid', label: 'Grid' },
        { id: 'inline-block', label: 'Inline Block' },
        { id: 'inline', label: 'Inline' },
        { id: 'none', label: 'None' },
      ]},
      { property: 'flex-direction', type: 'radio', defaults: 'row', options: [
        { id: 'row', label: 'Row' },
        { id: 'row-reverse', label: 'Row Rev' },
        { id: 'column', label: 'Col' },
        { id: 'column-reverse', label: 'Col Rev' },
      ]},
      { property: 'flex-wrap', type: 'radio', defaults: 'nowrap', options: [
        { id: 'nowrap', label: 'No' },
        { id: 'wrap', label: 'Yes' },
        { id: 'wrap-reverse', label: 'Reverse' },
      ]},
      { property: 'justify-content', type: 'select', defaults: 'flex-start', options: [
        { id: 'flex-start', label: 'Start' },
        { id: 'flex-end', label: 'End' },
        { id: 'center', label: 'Center' },
        { id: 'space-between', label: 'Between' },
        { id: 'space-around', label: 'Around' },
        { id: 'space-evenly', label: 'Evenly' },
      ]},
      { property: 'align-items', type: 'select', defaults: 'stretch', options: [
        { id: 'stretch', label: 'Stretch' },
        { id: 'flex-start', label: 'Start' },
        { id: 'flex-end', label: 'End' },
        { id: 'center', label: 'Center' },
        { id: 'baseline', label: 'Baseline' },
      ]},
      { property: 'gap', type: 'number', units: ['px', '%', 'em', 'rem'], defaults: '0' },
    ],
  },
  {
    name: 'Spacing',
    open: false,
    properties: [
      { property: 'padding', type: 'composite', properties: [
        { property: 'padding-top', type: 'number', units: ['px', '%', 'em', 'rem'], defaults: '0' },
        { property: 'padding-right', type: 'number', units: ['px', '%', 'em', 'rem'], defaults: '0' },
        { property: 'padding-bottom', type: 'number', units: ['px', '%', 'em', 'rem'], defaults: '0' },
        { property: 'padding-left', type: 'number', units: ['px', '%', 'em', 'rem'], defaults: '0' },
      ]},
      { property: 'margin', type: 'composite', properties: [
        { property: 'margin-top', type: 'number', units: ['px', '%', 'em', 'rem', 'auto'], defaults: '0' },
        { property: 'margin-right', type: 'number', units: ['px', '%', 'em', 'rem', 'auto'], defaults: '0' },
        { property: 'margin-bottom', type: 'number', units: ['px', '%', 'em', 'rem', 'auto'], defaults: '0' },
        { property: 'margin-left', type: 'number', units: ['px', '%', 'em', 'rem', 'auto'], defaults: '0' },
      ]},
    ],
  },
  {
    name: 'Size',
    open: false,
    properties: [
      { property: 'width', type: 'number', units: ['px', '%', 'vw', 'em', 'rem', 'auto'], defaults: '' },
      { property: 'min-width', type: 'number', units: ['px', '%', 'vw', 'em', 'rem'], defaults: '' },
      { property: 'max-width', type: 'number', units: ['px', '%', 'vw', 'em', 'rem'], defaults: '' },
      { property: 'height', type: 'number', units: ['px', '%', 'vh', 'em', 'rem', 'auto'], defaults: '' },
      { property: 'min-height', type: 'number', units: ['px', '%', 'vh', 'em', 'rem'], defaults: '' },
      { property: 'max-height', type: 'number', units: ['px', '%', 'vh', 'em', 'rem'], defaults: '' },
    ],
  },
  {
    name: 'Typography',
    open: false,
    properties: [
      { property: 'font-family', type: 'select', defaults: 'Arial, Helvetica, sans-serif', options: [
        { id: 'Arial, Helvetica, sans-serif', label: 'Arial' },
        { id: "'Inter', sans-serif", label: 'Inter' },
        { id: "'Roboto', sans-serif", label: 'Roboto' },
        { id: "'Open Sans', sans-serif", label: 'Open Sans' },
        { id: "'Lato', sans-serif", label: 'Lato' },
        { id: "'Montserrat', sans-serif", label: 'Montserrat' },
        { id: "'Poppins', sans-serif", label: 'Poppins' },
        { id: "'Playfair Display', serif", label: 'Playfair Display' },
        { id: 'Georgia, serif', label: 'Georgia' },
        { id: "'Times New Roman', serif", label: 'Times New Roman' },
        { id: "'Courier New', monospace", label: 'Courier New' },
      ]},
      { property: 'font-size', type: 'number', units: ['px', 'em', 'rem', '%', 'vw'], defaults: '16px' },
      { property: 'font-weight', type: 'select', defaults: '400', options: [
        { id: '100', label: 'Thin (100)' },
        { id: '200', label: 'Extra Light (200)' },
        { id: '300', label: 'Light (300)' },
        { id: '400', label: 'Normal (400)' },
        { id: '500', label: 'Medium (500)' },
        { id: '600', label: 'Semi Bold (600)' },
        { id: '700', label: 'Bold (700)' },
        { id: '800', label: 'Extra Bold (800)' },
        { id: '900', label: 'Black (900)' },
      ]},
      { property: 'font-style', type: 'radio', defaults: 'normal', options: [
        { id: 'normal', label: 'Normal' },
        { id: 'italic', label: 'Italic' },
      ]},
      { property: 'color', type: 'color', defaults: '#333333' },
      { property: 'line-height', type: 'number', units: ['px', 'em', '', '%'], defaults: '' },
      { property: 'letter-spacing', type: 'number', units: ['px', 'em'], defaults: '' },
      { property: 'text-align', type: 'radio', defaults: 'left', options: [
        { id: 'left', label: 'Left' },
        { id: 'center', label: 'Center' },
        { id: 'right', label: 'Right' },
        { id: 'justify', label: 'Justify' },
      ]},
      { property: 'text-decoration', type: 'select', defaults: 'none', options: [
        { id: 'none', label: 'None' },
        { id: 'underline', label: 'Underline' },
        { id: 'overline', label: 'Overline' },
        { id: 'line-through', label: 'Line Through' },
      ]},
      { property: 'text-transform', type: 'select', defaults: 'none', options: [
        { id: 'none', label: 'None' },
        { id: 'uppercase', label: 'Uppercase' },
        { id: 'lowercase', label: 'Lowercase' },
        { id: 'capitalize', label: 'Capitalize' },
      ]},
    ],
  },
  {
    name: 'Background',
    open: false,
    properties: [
      { property: 'background-color', type: 'color', defaults: '' },
      { property: 'background-image', type: 'file', defaults: '' },
      { property: 'background-repeat', type: 'select', defaults: 'repeat', options: [
        { id: 'repeat', label: 'Repeat' },
        { id: 'no-repeat', label: 'No Repeat' },
        { id: 'repeat-x', label: 'Repeat X' },
        { id: 'repeat-y', label: 'Repeat Y' },
      ]},
      { property: 'background-size', type: 'select', defaults: 'auto', options: [
        { id: 'auto', label: 'Auto' },
        { id: 'cover', label: 'Cover' },
        { id: 'contain', label: 'Contain' },
        { id: '100% 100%', label: '100%' },
      ]},
      { property: 'background-position', type: 'select', defaults: 'center center', options: [
        { id: 'center center', label: 'Center' },
        { id: 'top center', label: 'Top' },
        { id: 'bottom center', label: 'Bottom' },
        { id: 'left center', label: 'Left' },
        { id: 'right center', label: 'Right' },
      ]},
    ],
  },
  {
    name: 'Border',
    open: false,
    properties: [
      { property: 'border-width', type: 'number', units: ['px'], defaults: '0' },
      { property: 'border-style', type: 'select', defaults: 'none', options: [
        { id: 'none', label: 'None' },
        { id: 'solid', label: 'Solid' },
        { id: 'dashed', label: 'Dashed' },
        { id: 'dotted', label: 'Dotted' },
        { id: 'double', label: 'Double' },
        { id: 'groove', label: 'Groove' },
      ]},
      { property: 'border-color', type: 'color', defaults: '#000000' },
      { property: 'border-radius', type: 'composite', properties: [
        { property: 'border-top-left-radius', type: 'number', units: ['px', '%'], defaults: '0' },
        { property: 'border-top-right-radius', type: 'number', units: ['px', '%'], defaults: '0' },
        { property: 'border-bottom-right-radius', type: 'number', units: ['px', '%'], defaults: '0' },
        { property: 'border-bottom-left-radius', type: 'number', units: ['px', '%'], defaults: '0' },
      ]},
    ],
  },
  {
    name: 'Shadow',
    open: false,
    properties: [
      { property: 'box-shadow', type: 'stack', properties: [
        { property: 'box-shadow-h', type: 'number', units: ['px'], defaults: '0' },
        { property: 'box-shadow-v', type: 'number', units: ['px'], defaults: '0' },
        { property: 'box-shadow-blur', type: 'number', units: ['px'], defaults: '0' },
        { property: 'box-shadow-spread', type: 'number', units: ['px'], defaults: '0' },
        { property: 'box-shadow-color', type: 'color', defaults: 'rgba(0,0,0,0.1)' },
        { property: 'box-shadow-type', type: 'select', defaults: '', options: [
          { id: '', label: 'Outside' },
          { id: 'inset', label: 'Inside' },
        ]},
      ]},
      { property: 'text-shadow', type: 'stack', properties: [
        { property: 'text-shadow-h', type: 'number', units: ['px'], defaults: '0' },
        { property: 'text-shadow-v', type: 'number', units: ['px'], defaults: '0' },
        { property: 'text-shadow-blur', type: 'number', units: ['px'], defaults: '0' },
        { property: 'text-shadow-color', type: 'color', defaults: 'rgba(0,0,0,0.1)' },
      ]},
    ],
  },
  {
    name: 'Extra',
    open: false,
    properties: [
      { property: 'opacity', type: 'slider', defaults: 1, step: 0.01, max: 1, min: 0 },
      { property: 'overflow', type: 'select', defaults: 'visible', options: [
        { id: 'visible', label: 'Visible' },
        { id: 'hidden', label: 'Hidden' },
        { id: 'auto', label: 'Auto' },
        { id: 'scroll', label: 'Scroll' },
      ]},
      { property: 'cursor', type: 'select', defaults: 'auto', options: [
        { id: 'auto', label: 'Auto' },
        { id: 'pointer', label: 'Pointer' },
        { id: 'default', label: 'Default' },
        { id: 'move', label: 'Move' },
        { id: 'text', label: 'Text' },
        { id: 'not-allowed', label: 'Not Allowed' },
      ]},
      { property: 'z-index', type: 'number', defaults: '' },
      { property: 'position', type: 'select', defaults: '', options: [
        { id: 'static', label: 'Static' },
        { id: 'relative', label: 'Relative' },
        { id: 'absolute', label: 'Absolute' },
        { id: 'fixed', label: 'Fixed' },
        { id: 'sticky', label: 'Sticky' },
      ]},
      { property: 'top', type: 'number', units: ['px', '%', 'vh'], defaults: '' },
      { property: 'right', type: 'number', units: ['px', '%', 'vw'], defaults: '' },
      { property: 'bottom', type: 'number', units: ['px', '%', 'vh'], defaults: '' },
      { property: 'left', type: 'number', units: ['px', '%', 'vw'], defaults: '' },
      { property: 'transition', type: 'stack', properties: [
        { property: 'transition-property', type: 'select', defaults: 'all', options: [
          { id: 'all', label: 'All' },
          { id: 'opacity', label: 'Opacity' },
          { id: 'transform', label: 'Transform' },
          { id: 'background-color', label: 'Background' },
          { id: 'color', label: 'Color' },
          { id: 'box-shadow', label: 'Shadow' },
        ]},
        { property: 'transition-duration', type: 'number', units: ['s', 'ms'], defaults: '0.3s' },
        { property: 'transition-timing-function', type: 'select', defaults: 'ease', options: [
          { id: 'ease', label: 'Ease' },
          { id: 'linear', label: 'Linear' },
          { id: 'ease-in', label: 'Ease In' },
          { id: 'ease-out', label: 'Ease Out' },
          { id: 'ease-in-out', label: 'Ease In Out' },
        ]},
      ]},
    ],
  },
]
